<ng-container *ngIf="lastPayment">
    <div class="policy-info-row">
      <span class="label-col">
        {{ 'LAST_PAYMENT_RECEIVED' | translate}}
      </span>
      <div class="content-col">
        <div class="highlight dflex-align-center">{{ lastPayment.amount | currency }}
          <div [ngClass]="{'supporting-text supporting-marginleft' : !isAcmic, 'ml-1': isAcmic }">
            {{ 'on' }} {{ lastPayment.date | customDateFormat }}
          </div>
        </div>
      </div>
    </div>

    <div class="policy-info-row" *ngIf="policy.policynumber?.policyNumber.length === 10">
      <span class="label-col">
        {{ 'PAYMENT_METHOD' | translate}}
      </span>
      <span class="content-col highlight">
          {{ lastPayment.method }}
      </span>
    </div>            
    <hr class="my-insurance-main-hr">
</ng-container>